import { CircularProgress, Tooltip } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes } from "./../../../redux/payments/select_payment_requests_history";

let useStyles = makeStyles(() => ({
  root: {
    height: "70vh",
    minHeight: "400px",
  },
  tables: {
    fontFamily: "iransans",
    "& thead th": {
      fontWeight: "500",
      fontSize: "18px",
      padding: "5px 0px",
      color: "#CECECE",
      borderBottom: "none",
    },

    "& tbody tr td": {
      fontSize: "14px",
      padding: 0,
      border: "none",
    },
    "& tbody tr": {
      borderBottom: "1px solid #EFEFEF",
    },

    "& tbody tr:last-child ": {
      borderBottom: "none !important",
    },
  },
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
  emptyCard: {
    width: "98% !important",
    fontSize: 16,
    marginTop: 25,
    border: "1px solid black",
    height: 45,
    lineHeight: "2.8 !important",
    borderRadius: "4px !important",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "& td": {
    height: "50px !important",
  },
  "& td div": {
    lineHeight: 1.8,
    textAlign: "center",
    borderRadius: 100,
    // color: 'white',
    display: "inline-block",
    width: 80,
    marginRight: 15,
    marginLeft: 15,
  },

  "& td span": {
    width: 150,
    display: "block",
  },
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th , &:last-child tr": {},
}));

export default function Index() {
  let classes = useStyles();

  let dispatch = useDispatch();

  const [state, setState] = useState([]);

  let reducer = useSelector(
    (state) => state.selectPaymentRequestsHistoryReducer
  );

  useEffect(() => {
    if (reducer?.data?.length !== 0) {
      setState(reducer?.data);
    }
  }, [reducer?.data]);

  useEffect(() => {
    dispatch({ type: actionTypes.selectPaymentRequestsHistoryAsync });
  }, []);

  const handelStatus = (key) => {
    switch (key) {
      case "Submit":
        return "درخواست ارسال شده";
      case "Reject":
        return "درخواست رد شده";
      case "Request":
        return "درخواست ثبت شده";
      default:
        return "-";
    }
  };

  return (
    <TableContainer className={`mt-6 ${classes["root"]}`}>
      <Table
        aria-label="simple table"
        className={`${classes["tables"]} table-auto`}
      >
        <TableHead className="bg-gray-100">
          <TableRow>
            <TableCell style={{ color: "black" }} align="center">
              ردیف
            </TableCell>
            <TableCell align="center" style={{ minWidth: 150, color: "black" }}>
              نام ، نام خانوادگی
            </TableCell>
            <TableCell style={{ color: "black" }} align="center">
              کد ملی
            </TableCell>
            <TableCell style={{ color: "black" }} align="center">
              شماره شناسه
            </TableCell>
            <TableCell style={{ color: "black" }} align="center">
              مبلغ درخواستی
            </TableCell>
            {/*                         
                        <TableCell style={{color:"black"}} align="center">
                            تاریخ ثبت درخواست
                        </TableCell> */}
            <TableCell style={{ color: "black" }} align="center">
              تاریخ واریز وجه
            </TableCell>
            <TableCell style={{ color: "black" }} align="center">
              وضعیت تایید
            </TableCell>
            <TableCell style={{ color: "black" }} align="center">
              عملیات
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {state.length !== 0 && (
            <>
              {state.map((items, index) => {
                return (
                  <StyledTableRow
                    key={index}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      backgroundColor: index % 2 === 1 ? "#e1e1e155" : "",
                    }}
                  >
                    <TableCell align="center">
                      <div>{index + 1}</div>
                    </TableCell>
                    <TableCell align="center">
                      <div>
                        {`${items?.body?.member_first_name} ${items?.body?.member_last_name}`}
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div>{items?.body?.member_national_id}</div>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title={items?.body?.customer_bank_account_id}>
                        <div
                          style={{
                            maxWidth: "100px",
                            maxHeight: "100px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {items?.body?.customer_bank_account_id}
                        </div>
                      </Tooltip>
                    </TableCell>

                    <TableCell align="center">
                      <div>{items?.body?.request_amount}</div>
                    </TableCell>

                    <TableCell align="center">
                      <div>{items?.body?.payment_request_date}</div>
                    </TableCell>
                    <TableCell align="center">
                      <div style={{ minWidth: 120 }}>
                        {handelStatus(items?.body?.status)}
                      </div>
                    </TableCell>

                    <TableCell align="center">
                      <div>-</div>
                    </TableCell>
                  </StyledTableRow>
                );
              })}
            </>
          )}

          {reducer?.loading && (
            <StyledTableRow>
              <TableCell align="center" colSpan={8}>
                <div className="w-100 text-center mt-5">
                  <CircularProgress />
                </div>
              </TableCell>
            </StyledTableRow>
          )}

          {state.length === 0 && !reducer?.loading && (
            <StyledTableRow>
              <TableCell align="center" colSpan={8}>
                <div className={classes["emptyCard"]}>تاریخچه ای یافت نشد</div>
              </TableCell>
            </StyledTableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
